import {
  DEFAULT_REHAB_MERCHANT,
  buildRehabMerchantQuery,
  getRehabMerchantConfig,
  getRehabMerchantThemeStyle
} from './merchantConfig'
import { hasMarkdownCourseSource } from './merchantCourseSource'

export default {
  computed: {
    rehabMerchantState () {
      return (this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.rehabMerchant) || {
        key: DEFAULT_REHAB_MERCHANT.key,
        queryMerchant: ''
      }
    },
    rehabMerchantConfig () {
      return getRehabMerchantConfig(this.rehabMerchantState.key || this.rehabMerchantState.queryMerchant)
    },
    rehabMerchantThemeStyle () {
      return getRehabMerchantThemeStyle(this.rehabMerchantConfig)
    },
    rehabMerchantQuery () {
      return buildRehabMerchantQuery({ merchant: this.rehabMerchantState.queryMerchant || this.rehabMerchantConfig.key })
    },
    useMarkdownMerchantCourses () {
      return hasMarkdownCourseSource(this.rehabMerchantConfig)
    }
  },
  methods: {
    initRehabMerchantFromRoute () {
      const routeQuery = (this.$route && this.$route.query) || {}
      const merchant = routeQuery.merchant || routeQuery.merchantId || routeQuery.brand || this.rehabMerchantState.queryMerchant || this.rehabMerchantState.key
      const merchantConfig = getRehabMerchantConfig(merchant)
      const payload = {
        key: merchantConfig.key,
        queryMerchant: merchant ? String(merchant).trim() : merchantConfig.key
      }
      this.$store.commit('user/setRehabMerchant', payload)
      return merchantConfig
    },
    applyRehabMerchantTheme () {
      if (typeof document === 'undefined' || !document.documentElement) return
      const themeStyle = getRehabMerchantThemeStyle(this.rehabMerchantConfig)
      Object.keys(themeStyle).forEach(key => {
        document.documentElement.style.setProperty(key, themeStyle[key])
      })
      document.title = this.rehabMerchantConfig.browserTitle || `${this.rehabMerchantConfig.name}课程中心`
    },
    buildRehabRouteQuery (extraQuery = {}) {
      return {
        ...this.rehabMerchantQuery,
        ...extraQuery
      }
    }
  }
}
